import { initGlobalState } from 'qiankun'

const state = {
}
// 初始化 state
export const actions = initGlobalState(state)
